import Portal from "./Portal";

export default function Modal({ children }) {
    return (
        <Portal>
            <div className='fixed inset-0 bg-docpgrModal4 backdrop-blur flex justify-center items-center z-[9999]'>
                <div className='relative bg-white/90 rounded-2xl p-6 space-y-6 w-full max-w-md shadow-xl border border-slate-200'>
                    {children}    
                </div>    
            </div> 
        </Portal>
    )
}